export const boxWrapper = {
  backgroundColor: '#fff',
  height: '100%',
  display: 'flex',
  flexDirection: 'row-reverse',
}

export const tabsStyles = {
  width: 'auto',
  minWidth: 48,
  '& .MuiTab-root': {
    minWidth: 48,
    width: 48,
    height: 'auto',
    padding: 1,
    paddingTop: 2,
    paddingBottom: 2,
    writingMode: 'vertical-rl',
    transform: 'rotate(180deg)',
    letterSpacing: 1,
    fontSize: 16,
    fontWeight: 600,
    textTransform: 'capitalize',
    color: '#000',
  },
}

export const tabsMargin = {
  marginBottom: '10px',
}

export const panelBoxStyles = {
  transition: 'width 220ms ease',
  overflow: 'hidden',
  borderLeft: '1px solid',
  borderColor: 'divider',
  bgcolor: 'background.paper',
}
